import React from 'react';
import AppLogo from '@/components/ui/AppLogo';

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-charcoal/12 py-10 px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Logo + brand */}
        <div className="flex items-center gap-3">
          <AppLogo size={22} text="AIRCHECK" />
          <span
            className="font-body text-sm"
            style={{ color: 'var(--color-charcoal-light)' }}
          >
            A show about making shows.
          </span>
        </div>

        {/* Links */}
        <div className="flex items-center gap-8">
          {[
            { label: 'Episodes', href: '#episodes' },
            { label: 'Newsletter', href: '#rundown' },
            { label: 'YouTube', href: 'https://youtube.com' },
            { label: 'Privacy', href: '#' },
          ].map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="font-body text-sm font-medium transition-colors duration-200"
              style={{ color: 'var(--color-charcoal-light)' }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.color = 'var(--color-brass)')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = 'var(--color-charcoal-light)')
              }
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Copyright */}
        <p
          className="font-body text-sm"
          style={{ color: 'var(--color-charcoal-light)' }}
        >
          © 2026 Aircheck
        </p>
      </div>
    </footer>
  );
};

export default Footer;